import { isAppError } from '@/lib/supabase/errors'

/** User-safe Dutch message for any thrown value. */
export function errorMessage(error: unknown, fallback = 'Er ging iets mis. Probeer het opnieuw.'): string {
  return isAppError(error) ? error.userMessage : fallback
}

/** Current local wall-clock time as HH:mm. */
export function nowLocalTime(): string {
  const now = new Date()
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

/** Device timezone, e.g. Europe/Amsterdam. */
export function deviceTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Amsterdam'
}
